// Maps a Section.vertical_spacing preset (chosen in the FMS "Spacing" control:
// compact / normal / spacious) to the section's OWN vertical padding.
//
// Why padding (py) and not an outer margin: each section already carries a
// large internal py, so a wrapper margin was visually swamped and the preset
// looked like it did nothing. Driving the section's own py makes the control
// clearly change the space around the section's content in both directions.
//
// `fallback` is the section's OWN existing padding. It is returned for both
// the "normal" preset and the null / unset case, so:
//   - live sites that never set a preset render byte-for-byte as before
//     (additive — Design A client sites are not disturbed),
//   - "normal" reads as "the section's standard spacing",
//   - only "compact" / "spacious" actually change the padding.
// Each caller passes its current py string so its default look is preserved.
export const sectionPaddingY = (
  preset?: string | null,
  fallback = "py-12 md:py-20 lg:py-24"
): string => {
  switch (preset) {
    case "compact":
      return "py-6 md:py-10";
    case "spacious":
      return "py-20 md:py-28 lg:py-36";
    default:
      return fallback; // "normal" / unset → the section's existing rhythm
  }
};
